<div id="canvas-container">
    <canvas #canvas width="400" height="400"></canvas>
  </div>